import React from "react";

const CalorieInfo = (props) => {
    const calorieInfo = props.data.map((calorie, index) => {
        const { servingText, calories, caloriesFromFat } = calorie;
        const fromFatText =
            caloriesFromFat !== null ? (
                <div>
                    <b>Calories from Fat</b> {caloriesFromFat}
                </div>
            ) : null;

        return (
            <div key={`calories_${index}_${props.panel}`} className="column">
                <div className="calorie-count">{calories}</div>
                {servingText}
                <h2>Calories</h2>
                {fromFatText && <div>Calories from Fat {fromFatText}</div>}
            </div>
        );
    });

    return (
        <div className="calories">
            <div className="row">{calorieInfo}</div>
        </div>
    );
};

export default CalorieInfo;
